<template>
  <div class="upload-item" :class="{ 'forbid': forbid, 'have-img': imgUrl, 'is-pdf': fileType === 'pdf' }" v-loading="upload.loading">

    <!-- 上传好的图片 -->
    <div class="uploaded upload-box" v-if="imgUrl">
      <a v-if="fileType === 'pdf'" class="img-nav" target="_blank" :href="imgUrl">
        <img src="../../assets/imgs/pdf.png" @drop="uploadDragImg($event, true)" @dragover="dragover" class="img">

        <div class="img-name-nav">
          <div :title="fileName" class="img-name">{{fileName}}</div>
        </div>

      </a>

      <img v-else :src="imgUrl" @drop="uploadDragImg($event, true)" @dragover="dragover" class="img" @click="doReviewImage">
    </div>

    <!-- 重新上传 没有被禁用，且有照片的时候才有显示重新上传-->
    <label class="reupload" :for="uploadInputId" :class="{ 'bottom-0': verifyNotPass }" v-if="!forbid && imgUrl" @click="$refs.uploadInput.value = null">重新上传</label>


    <!-- 删除 非重新上传或者未支付，有图片-->
    <div class="delete" @click="doDeleteFile" v-if="isMulti && (!isReupload || isBeforePay) && imgUrl">
      <img src="../../assets/imgs/upload/delete.png">
      <span>删除</span>
    </div>

    <!-- 合格 一定要上传了图片才盖章 -->
    <div class="verify-passed verify-cover" @click="doReviewImage" v-if="verifyPassed && imgUrl">
      <img src="../../assets/imgs/upload/pass.png" class="cover-img">
    </div>

    <!-- 不合格 一定要上传了图片才盖章 -->
    <div class="verify-not-pass verify-cover" @click="doReviewImage" v-if="verifyNotPass && imgUrl">
      <img src="../../assets/imgs/upload/not-pass.png" class="cover-img">
    </div>

    <!-- 只有空的上传才可以是多选 -->
    <input ref="uploadInput" :id="uploadInputId" type="file" class="faraway-left" :accept="getType()" :multiple="isMulti && !imgUrl" @change="doUploadFile">

    <!-- 空的上传 -->
    <div class="upload-box" v-if="!imgUrl">
      <div class="tip forbid-tip" v-if="forbid">
        <img v-if="forbid" src="../../assets/imgs/upload/forbid.png">
        <div class="tip-text">点击或拖拽上传</div>
      </div>

      <label @dragover="dragover" @drop="uploadDragImg" :for="uploadInputId" @click="$refs.uploadInput.value = null" class="tip valid-tip" v-else>
        <img v-if="!forbid" src="../../assets/imgs/upload/upload.png">
        <div class="tip-text">点击或拖拽上传</div>
      </label>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import utils from '../../libs/utils';

export default {
  name: 'uploadItem',
  props: {
    imgUrl: {
      // 实际要显示图片的字段
      type: String,
    },
    upload: {
      // 外部的upload对象
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    forbid: {
      // 是否禁用
      type: Boolean,
      default: false,
    },
    isMulti: {
      // 是不是多页
      type: Boolean,
      default: false,
    },
    verifyPassed: {
      // 预审通过
      type: Boolean,
      default: false,
    },
    verifyNotPass: {
      // 预审未通过 （因为不同资料的判断是否通过的字段和值都不同，所以还是在外面判断好直接传递进来比较好）
      type: Boolean,
      default: false,
    },
    isReupload: {
      // 下单的时候的逻辑和重新上传的逻辑不一样
      type: Boolean,
      default: false,
    },
    pdf: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
    isBeforePay: {
      // 订单状态是否还没支付，没支付则可以删除
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadInputId: `input-${utils.ranString(10)}`,
    };
  },
  computed: {
    fileType() {
      const url = this.imgUrl;
      if (url) {
        const z = url.split('?')[0];
        if (z.split('.').indexOf('pdf') > -1) {
          return 'pdf';
        }
      }
    },
  },
  methods: {
    getType() {
      return this.pdf ? 'application/pdf, image/jpeg, image/jpg, image/png' : 'image/jpeg, image/jpg, image/png';
    },

    // 取消拖拽默认事件
    dragover(e) {
      e.preventDefault();
    },

    // 拖拽上传
    uploadDragImg(e, uploaded) {
      e.preventDefault();
      if (!uploaded) {
        const input = e.dataTransfer;// 获取到第一个上传的文件对象
        this.uploadFile(input);
      }
    },

    // 上传操作
    uploadFile(img) {
      if (!img.files || !img.files[0]) return;
      const arr = this.getType().split(', ');
      const fileNameType = img.files[0].name.substring(img.files[0].name.lastIndexOf('.') + 1).toLowerCase();
      if (arr.indexOf(img.files[0].type) === -1) {
        Message.warning({
          message: '不支持上传该类型文件',
        });
        return;
      }
      if (arr.filter(type => type.indexOf(fileNameType) > -1).length === 0) {
        Message.warning({
          message: '不支持上传该类型文件',
        });
        return;
      }

      // 转为真正的数组
      const filesArr = Array.from(img.files);
      if (filesArr.some(file => file.name.indexOf('pdf') === -1 && file.size > 10 * 1024 * 1024)) {
        Message.warning({
          message: '图片大小不能超过10M，请重新选择',
        });
        return;
      }

      // 解决IE11下input(file)change方法会执行两遍。第二遍file为null
      if (!(img.files && img.files.length > 0)) return;
      this.$emit(
        'uploadFile',
        this.isMulti ? img.files : img.files[0],
        this.upload.pos ? this.upload.pos : this.upload.id,
      );
      this.$emit('saveUploadInputId', this.uploadInputId);
      if (this.$refs.uploadInput) this.$refs.uploadInput.value = null;
    },

    // 点击上传资料
    doUploadFile(e) {
      const input = e.target;
      this.uploadFile(input);
    },

    // 删除图片
    doDeleteFile() {
      this.$refs.uploadInput.value = null;
      this.$emit('deleteFile');
    },

    // 预览图片
    doReviewImage() {
      if (this.imgUrl.indexOf('.pdf') > -1) {
        window.open(this.imgUrl);
        return;
      }
      this.$emit('reviewImage', this.imgUrl);
      this.$emit('saveUploadInputId', this.uploadInputId);
    },

  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.upload-item {
  width: 160px;
  height: 160px;
  border: 1px solid @main;
  border-radius: 4px;
  background-color: rgba(94, 155, 225, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  &.forbid {
    background-color: @active;
    border: 1px solid @border;
    .tip-text {
      color: @text-light-gray !important;
      cursor: default;
    }
  }
  &.have-img {
    border: 1px solid #f0f0f0;
    &.is-pdf {
       border: none;
    }
  }
  &:hover .delete {
    top: 5px;
  }
  &:hover .reupload {
    bottom: 0;
  }
  .faraway-left {
    position: absolute;
    left: -99999px; // 不能写top，直接平移到左边，不然点击之后会往上跳
  }
  .uploading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .upload-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .uploaded {
    width: 100%;
    height: 100%;
    position: relative;
    .img-nav {
      width: 100%;
      height: 100%;
      position: relative;
      .img-name-nav {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 3px;
        background-color: #ffffff;
        transform: translate(-50%, -50%);
        z-index: 3;
        max-width: calc(100% - 10px);
      }
      .img-name {
        // text-align: center;
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 1;
        font-size: 14px;
        color: #777;
        padding: 7px 10px;
        // max-width: calc(100% - 10px);
        font-size: 14px;
        color: #6f6f6f;
        background-color: #ffffff;
        border: solid 1px rgba(94, 155, 225, 0.5);
      }
    }
    .img {
      max-width: 100%;
      width: 100%;
      position: relative;
      z-index: 1;
      cursor: pointer;
    }
  }
  .delete {
    position: absolute;
    right: 5px;
    top: -31px;
    display: flex;
    z-index: 3;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    width: 56px;
    height: 26px;
    color: white;
    transition: top 0.5s;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.6);
    span {
      margin-left: 4px;
    }
  }
  .reupload {
    position: absolute;
    left: 0;
    bottom: -30px;
    display: block;
    display: flex;
    cursor: pointer;
    z-index: 3;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    width: 100%;
    height: 30px;
    transition: bottom 0.5s;
    background-color: rgba(94, 155, 225, 0.9);
    &.bottom-0 {
      bottom: 0;
      background-color: @text-red;
    }
    .reupload-item {
      position: relative;
      float: left;
      width: 50%;
      text-align: center;
      cursor: pointer;
    }
    .reupload-item + .reupload-item::before {
      content: '';
      position: absolute;
      top: -2px;
      left: 0;
      width: 1px;
      height: 18px;
      background-color: white;
    }
  }
  .verify-cover {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    .cover-img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .verify-passed {
    background-color: rgba(0, 0, 0, .3);
  }
  .verify-not-pass {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .tip {
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    &:hover img {
      opacity: 0.8;
    }
    &:hover .tip-text {
      opacity: 0.8;
    }
    &.valid-tip {
      cursor: pointer;
    }
    img {
      width: 36px;
      height: 36px;
    }
    .tip-text {
      text-align: left;
      margin-top: 10px;
      padding: 0 10px;
      color: #5e9be1;
      font-size: 12px;
      line-height: 16px;
      .drag-text {
        color: #aaa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-item.vue